import { useCallback } from 'react';


export const useLoadOptions = <T, E>(hookState: { data: T, loading: boolean, isError: boolean, error: E | null }) => {
    const { data, loading, isError, error } = hookState;

    return useCallback(() => {
        if (loading) {

            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return new Promise<T>(() => {});
        }

        if (isError) {
            return Promise.reject(error);
        }

        return Promise.resolve(data);

    }, [data, loading, isError, error]);
};